import PropTypes from 'prop-types';
import React from 'react';

import {getSectionHeaderBackgroundStyle, hasCollectionBackground} from '../../utils/getCollectionBackground';
import './text.css';

function getTextPositionClass(position) {
  switch (String(position || '').toLowerCase()) {
    case 'center':
      return 'text-center';
    case 'right':
      return 'text-right';
    default:
      return '';
  }
}

const Text = ({slice}) => {
  const bgStyle = getSectionHeaderBackgroundStyle(slice.primary.text_background_color);
  const hasBg = hasCollectionBackground(slice.primary.text_background_color);
  const positionClass = getTextPositionClass(slice.primary.text_position);

  return (
    <section
      className={hasBg ? 'bg-section text-field ' + slice?.source : 'text-field ' + slice?.source}
      style={bgStyle}
    >
      <div
        className={[hasBg ? 'bg-color-variant' : '', 'text-field-inner', positionClass].filter(Boolean).join(' ')}
        dangerouslySetInnerHTML={{
          __html: slice.primary?.text?.html || slice.primary?.text[0]?.html || slice.primary.html,
        }}
      ></div>
    </section>
  );
};

Text.propTypes = {
  slice: PropTypes.object,
};

export default Text;
